import { useEffect, useState } from "react";

import {
	type DocumentVersionIndex,
	loadDocumentVersionIndex,
} from "./documentVersionIndex";

const EMPTY_INDEX: DocumentVersionIndex = new Map();

/**
 * The version index, fetched lazily the first time a card that wants it mounts.
 *
 * Starts empty and stays empty on any failure, so the caller's render path is
 * "extra line or no extra line" — never "loading" and never an error state.
 */
export function useDocumentVersionIndex(): DocumentVersionIndex {
	const [index, setIndex] = useState<DocumentVersionIndex>(EMPTY_INDEX);

	useEffect(() => {
		let alive = true;
		void loadDocumentVersionIndex().then((loaded) => {
			if (alive) setIndex(loaded);
		});
		return () => {
			alive = false;
		};
	}, []);

	return index;
}
